<template>
    <DFormRow
        :label="__('customers.contracts.relation_type')"
        is-required
        :error="errors.relation_type"
    >
        <DSelect
            :options="options"
            :model-value="relationType"
            :is-valid="isFormFieldValid('relation_type')"
            @update:modelValue="$emit('update:relationType', $event)"
        />
    </DFormRow>
    <DFormRow
        :label="__('customers.contracts.relation_reference')"
        :error="errors.relation_reference"
    >
        <DInput
            :model-value="relationReference"
            :is-valid="isFormFieldValid('relation_reference')"
            @update:modelValue="$emit('update:relationReference', $event)"
        />
    </DFormRow>
</template>

<script setup>
defineProps(
    {
        options: {
            type: Object,
            default: () => { return {} }
        },
        relationType: {
            type: String,
            default: ''
        },
        relationReference: {
            type: String,
            default: ''
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    }
)
defineEmits(['update:relationType', 'update:relationReference'])
</script>

<style scoped lang="scss">

</style>
